import {
  refreshServiceWorkers,
  useNotificationPermission,
  useServiceWorker,
} from "../hooks/useWebworker";
import { useEffect } from "react";
// import { usePocketBase } from "./hooks/usePocketBase";
import { Box, Button, Typography } from "@mui/material";

export function HomePage() {
  const registerWorker = useServiceWorker();
  const notificationPermission = useNotificationPermission();
  //const pb = usePocketBase();

  useEffect(() => {
    registerWorker();
  }, []);

  async function handleOnClick() {
    await notificationPermission();
  }
  return (
    <Box sx={{ my: 4 }}>
      <Typography variant="h4" component="h1" sx={{ mb: 2 }}>
        Nascar Pickems
      </Typography>
      <Button variant="contained" onClick={handleOnClick}>
        Enable Notifications
      </Button>
      <Button variant="contained" onClick={refreshServiceWorkers}>
        Remove Service Workers
      </Button>
    </Box>
  );
}

export default HomePage;
